import React, { useState, useEffect, forwardRef } from "react";
import { Spin, Tooltip,notification } from "antd";
import { useDispatch } from "react-redux";

import SectionHeader from "../../components/global/SectionHeader";
import { API_URL } from "../../environment";
import { ALLLEAVES_DATA } from "../../redux/Store/constants";
import { useNavigate, Link } from "react-router-dom";
import "../leaves/Leaveform.css";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { useSidebar } from "../../components/provider/Provider";
import moment from "moment";
import Layout from "../../components/global/layout";
import ApiClient from "../../methods/api/apiClient";

const Announcement = () => {
  let history = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [array, setArray] = useState([]);
  const { setCourseId } = useSidebar();
  const [backgroundImage, setBackgroundImage] = useState("");
  const [singledata, setsingledata] = useState();
  const [showmodel,setModel]=useState(false)

  useEffect(() => {
    userDetails();
  }, []);
  const userDetails = () => {
    setLoading(true);
    fetch(`${API_URL}announcementListing?page=1&count=1000&`, {
      method: "GET",

      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setArray(res && res.data);
        if (res && res.data && res.data.access_token) {
          dispatch({
            type: ALLLEAVES_DATA,
            payload: res,
          });
        }
        if (res.code === 401) {
          localStorage.clear();
          history("/");
        }
        setLoading(false);
      });
  };
  
  const chapterIdHandle = (id) => {
    setCourseId(id);
    localStorage.setItem("appliedlives", id);
  };

  const showmodal = (item) => {
    let payload = {
      id: item?._id,
    };

    setLoading(true);
    ApiClient.get(`announcement`, payload).then((res) => {
      if (res.success) {
        setsingledata(res?.data);
        setLoading(false);

        const category = res?.data?.category

        let backgroundImageUrl = ""
        if (category === 'Festival') {
          backgroundImageUrl = 'url(/assets/img/festivels-5.png)'
        } else if (category === 'Birthday') {
          backgroundImageUrl = 'url(/assets/img/birthday.png)'
        } else if (category === 'Notice') {
          backgroundImageUrl = 'url(/assets/img/notice.png)'
        } else if (category === 'Holiday') {
          backgroundImageUrl = 'url(/assets/img/Independence.png)'
        } else if (category === 'Celebration') {
          backgroundImageUrl = 'url(/assets/img/workaniversary.png)'
        } else if (category === 'Activity') {
          backgroundImageUrl = 'url(/assets/img/activity.png)'
        } else {
          backgroundImageUrl = 'url(/assets/img/festivels-5.png)'
        }
        setBackgroundImage(backgroundImageUrl)
        setModel(true)
      }
      
      
      
      
      else {
        localStorage.clear();
        history("/");
        setTimeout(() => {
          notification.error({
            message: "Unauthorized",
            description: "Your Session Has Expired. Please logIn.",
          });
        }, 1000);
      }
      // setLoading(false);
    });
  };
  const detailPage =(e)=>{
    history('/announcementDetails?id='+e)
  }
  
  
  const columns = [
    {
      title: "Tittle",
      dataIndex: "subject",
      field: "subject",
      render: (text, record) => (
        <>
          {text && text.subject ? (
         <span className="text-link" style={{ cursor: "pointer" }} onClick={(e) => showmodal(text)} >
              <Tooltip title="View">
                <span
                  className="text-capitalize text-link d-inline m-0"
              
                >
                  {text.subject}
                </span>
              </Tooltip>
            </span>
          ) : (
            "--"
          )}
        </>
      ),
    },

    {
      title: "Category",
      dataIndex: "category",
      field: "category  ",
      render: (text, record) => {
        const cleanDescription =
          text && text.category
            ? text.category.replace(/<[^>]+>/g, "")
            : "";
        const truncatedDescription = cleanDescription
          .split(" ")
          .slice(0, 10)
          .join(" ");
        const displayDescription =
          cleanDescription.length > 10
            ? truncatedDescription + "..."
            : truncatedDescription;

        return (
          <>
            {cleanDescription ? (
              <span
                className="text-capitalize"
                onClick={() => chapterIdHandle(text.id)}
              >
                {displayDescription}
              </span>
            ) : (
              "--"
            )}
          </>
        );
      },
    },

    {
      title: " Date",
      dataIndex: "date",
      field: "date",
      render: (text, record) => (
        <>{moment(text && text.date).format("DD MMM YYYY")}</>
      ),
    },
  ];
  const newlyAddedChapter =
    array && array.length
      ? array.map((items) => {
        localStorage.setItem("rolesid", items.id);
        return {
          ...items,
        };
      })
      : [];
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  return (
    <Layout>
      <div>

        <div className="main-content">
          <div className="headings">
            <SectionHeader title="Announcements List " />
          </div>
          <div className="section table table-striped">

            <Spin spinning={loading}>
              <MaterialTable
                options={{
                  showTitle: false,
                  pageSize: 10,
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  emptyRowsWhenPaging: false,
                }}
                columns={columns}
                data={newlyAddedChapter}
                icons={tableIcons}
              />
            </Spin>
          </div>
        </div>



        {showmodel ? (
                     <div
                     className="modal d-block scroll_fade"
                    
                   >
                     <div
                       className="modal-dialog event-dialog modal-dialog-centered modal-lg"
                       role="document"
                     >
                       <div className="modal-content event-content"
                         style={{
                           backgroundImage: backgroundImage,
                           backgroundSize: "cover",
                           backgroundPosition: "center",
                         }}>
                         <div className="modal-header event-header py-3">
                           <h5 className="detail-text" id="exampleModalLabel">
                             Announcement
                           </h5>



{

}



                           
                           {/* <button
                             type="button"
                             className="close"
                             data-dismiss="modal"
                             aria-label="Close"
                           >
                             <span aria-hidden="true">&times;</span>
                           </button> */}
                         </div>
                         <div className="modal-body event-body ml-3 mr-3 mt-3">



                           <table className="modal-table w-100">
                             <tr>
                               {/* <th className="text-left">
                               {/* <h6 className="d-flex justify-content-between">
                                 Event <span>:</span>
                               </h6></th>{" "}  */}
                               <td className="text-center text-capitalize event-name"><span>{singledata ? singledata?.subject : "--"}</span></td>
                             </tr>
                             <tr>
                               {/* <th className="text-left">
                               <h6 className="d-flex justify-content-between">
                                 Event Date <span>:</span>
                               </h6></th>{" "} */}
                               <td className="text-center text-capitalize event-date"><span>
                                 {moment(singledata?.date).format("DD MMM YY")}
                               </span></td>
                             </tr>
                             <tr>
                               {/* <th className="text-left">
                               <h6 className="d-flex justify-content-between">
                                 Announcement <span>:</span>
                               </h6></th> */}
                               <td className="text-center text-capitalize event-detail"><span
                                 dangerouslySetInnerHTML={{
                                   __html: singledata
                                     ? singledata?.description
                                     : "--",
                                 }}
                               /></td>
                             </tr>

                             <tr>
                             {singledata.image?<>
                             <img src={API_URL+singledata.image}></img>
                             
                             </>:''}
                        
                             </tr>
                           </table>
                         </div>
                         <div className="modal-footer event-footer justify-content-center mb-2">
                           <button
                             type="button"
                             className="btn btn-primary btn-w"
                             data-dismiss="modal"
                             onClick={(e) =>setModel(false)}
                           >
                             Close
                           </button>
                         </div>
                       </div>
                     </div>
                   </div>
      ) : (
        ""
      )}
        
      </div>
    </Layout>
  );
};

export default Announcement;
